module.exports = __webpack_public_path__ + "img/conmebol.f4c0f133.jpg";